import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Space, Flex, Text } from '@mantine/core';
import classNames from 'classnames';
import { AuthFormHoc } from 'src/hoc';
import { Auth } from 'aws-amplify';
import { PATHS } from 'src/constants';
import { Button, Link } from '@common/components';
import { useAlert } from '@common/hooks';

import styles from './styles.module.scss';
import { getOnboardingStatus } from 'src/helpers/localStorageHelper';
import { setIsAuthorizeAction, useAppDispatch } from 'src/store';
import { ChevronLeft } from '@geist-ui/icons';

const VerifyEmailBox = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { showAlert } = useAlert();
  const [t] = useTranslation('auth');
  const [n] = useTranslation('nav');
  const [c] = useTranslation('common');
  const { email, isRecover, password } = location.state;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoginError, setLoginError] = useState<boolean>(false);

  const onNavigateHandler = async (): Promise<void> => {
    if (isRecover) navigate(PATHS.RESET_PASSWORD);
    if (!isRecover) {
      setIsLoading(true);
      try {
        await Auth.signIn(email, password);
        location.state = {};
        localStorage.removeItem('personalForm');
        localStorage.removeItem('isPersonalInfoFormEnabled');
        if (getOnboardingStatus() === 'true') {
          dispatch(setIsAuthorizeAction(true));
          navigate(PATHS.MAIN);
        } else {
          navigate(PATHS.ONBOARDING);
        }
      } catch (error) {
        if (error instanceof Error) {
          showAlert({
            id: error.message,
            title: c('Error'),
            message: error.message,
            variant: 'error',
          });
          setLoginError(true);
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const resendEmailLinkHandler = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const response = (): Promise<void> => (isRecover ? Auth.forgotPassword(email) : Auth.resendSignUp(email));
      const res:any = await response();
      // console.log( res);
      if ( res?.CodeDeliveryDetails?.Destination ) {
        showAlert({
          id: res?.Destination,
          title: 'Resend Email Verification',
          message: 'Email Verification Sent Success',
          variant: 'success',
        });
      }

    } catch (error) {
      if (error instanceof Error) {
        showAlert({
          id: error.message,
          title: c('Error'),
          message: error.message,
          variant: 'error',
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!email) navigate(PATHS.LOGIN);
  }, []);

  return (
    <Flex justify={"center"} align={"center"} direction={{ base: 'column' }}>
      <AuthFormHoc
        classContainer={styles.formContainer}
        isLoading={isLoading}
        link={
          isRecover ? (
            <></>
          ) : (
            <Link navigateTo={PATHS.SIGN_UP}>
              <Flex>
                <ChevronLeft color="#5b5eff" />{' '}
                <Text color={'#000000'} fw={400}>
                  {n('navBack')}
                </Text>
                <span className={styles['visually-hidden']}>{n('backToSignUp')}</span>
              </Flex>
            </Link>
          )
        }
        title={`${t('confirmEmail')}`}
        description={
          <>
            <p
              className={classNames(styles.description, {
                [styles['has_error']]: isLoginError,
              })}>
              {isRecover ? t('checkYourEmailRecover') : t('checkYourEmail')}
            </p>
          </>
        }
      />
      {/* {isRecover && <Link navigateTo={PATHS.LOGIN}>{t('backToLogin')}</Link>} */}
      {/* <Space h={'md'} /> */}
      <Button className={styles.resend_button}   color={'gray'} onClick={resendEmailLinkHandler}>
        {isRecover ? t('resendLinkRecover') : t('resendLink')}
      </Button>
      {/* <Space h={'lg'} /> */}
      {/* {!isRecover && (
        <Button className={styles.resend_button} fullWidth onClick={onNavigateHandler} loading={isLoading}>
          {t('letsStart')}
        </Button>
      )} */}
      <Space h={'lg'} />
      <Flex className={styles.text_gray}  w={"80%"}  direction={"column"} justify={"center"} align={"center"} gap={"0"} >
        <p className={styles.description} style={{ margin : 0}}>
          {t('contactDescrption')}
        </p>
        <Link  navigateTo={"mailto:hello@vially.io"} >hello@vially.io</Link>
      </Flex>
    </Flex>
  );
};

export default VerifyEmailBox;
